import { graphql } from '~/types/gql/generated'

export const VerifyAuthGqlQuery = graphql(`
  query VerifyAuth {
    verifyAuth
  }
`)
